import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import LargeEvent from "./large_event";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    events: PropTypes.array,
  },
  render() {
    if (this.props.events.length === 0) {
      return "";
    }
    const events = this.props.events.map(function(event) {
      return <LargeEvent event={event} key={event.id} />;
    });
    return (
      <div>
        <article className="timeline-box">
          <h2 className="left">
            <i className="far fa-calendar-alt icon_blue" aria-hidden="true" />&nbsp;いま「参加した人」がいるイベント
          </h2>
          <div className="touch-wrap">
            <div className="touch">{events}</div>
          </div>
        </article>
      </div>
    );
  },
});
